module.exports = "/_next/static/images/game-1-phone-attachment-angry-95481fb8ea25726b6c3799391f23a81c.gif";